import { XStack, YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { getWindowOutcomeDisplay } from '../ck-debug.utils';

import type { CkWindowResult } from '../ck-debug.types';

function WindowRow({ window }: { window: CkWindowResult }) {
  const display = getWindowOutcomeDisplay(window.outcome);

  return (
    <YStack className="py-1.5 gap-0.5 border-b border-border last:border-b-0">
      <XStack className="items-center gap-2">
        <span
          className={cn('w-2 h-2 rounded-full shrink-0', display.dot)}
          title={display.label}
        />
        <span className="text-xs text-foreground truncate flex-1">
          {window.title || '(untitled)'}
        </span>
        {window.durationMs !== null && (
          <span className="text-[10px] font-mono text-foreground-muted tabular-nums shrink-0">
            {window.durationMs}ms
          </span>
        )}
      </XStack>

      <XStack className="items-center gap-2 pl-4 flex-wrap">
        {window.domain && (
          <span className="text-[10px] font-mono text-foreground-subtle truncate">
            {window.domain}
          </span>
        )}
        {window.parserName && (
          <span className="text-[10px] text-foreground-subtle">
            {window.parserName}
          </span>
        )}
      </XStack>

      {window.failureReason && (
        <span className="text-[10px] text-danger-11 pl-4 break-words">
          {window.failureReason}
        </span>
      )}
      {window.skipReason && (
        <span className="text-[10px] text-warning-11 pl-4 break-words">
          {window.skipReason}
        </span>
      )}
    </YStack>
  );
}

export function CkDebugWindowList({ windows }: { windows: CkWindowResult[] }) {
  return (
    <YStack className="gap-0">
      {windows.map((w, i) => (
        <WindowRow key={`${w.title}-${i}`} window={w} />
      ))}
    </YStack>
  );
}
